// src/api/hooks/useGetLearningObjectsById.ts
import { useQuery } from '@tanstack/react-query';

import { useAtlassianUser } from 'src/hooks/useAtlassianUser';

import { apiClient } from '../client';

export const LEARNING_OBJECT_QUERY_KEY = 'learningObjectsById';

export const useGetLearningObjectsById = (courseId: string) => {
  const { user, isLoading: isUserLoading } = useAtlassianUser();

  const query = useQuery({
    queryKey: [LEARNING_OBJECT_QUERY_KEY, courseId, user?.account_id],
    queryFn: () =>
      apiClient.adobe.getLearningObjectsById(courseId, {
        email: user?.email,
        aaid: user?.account_id,
        include: 'instances.loResources.resources,enrollment',
      }),
    enabled: !!user && !!courseId,
    // Keep data fresh for navigation between routes, need broader discussion on how long to keep the data fresh for.
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  return {
    ...query,
    isLoading: isUserLoading || query.isLoading,
  };
};
